class ShopsInBoundsCtrl {

    constructor($scope, storeServ, mapServ, mapHelperServ) {
        this.$scope = $scope;
        this.storeServ = storeServ;
        this.mapServ = mapServ;
        this.mapHelperServ = mapHelperServ;

        this.markerClustererOptions = this.mapServ.readMarkerClustererOptions();

        this.clusteringEndListener = this.addClusteringEndListener();

        this.addComponentDestroyListener();
    }

    addClusteringEndListener() {
        return this.markerClusterer.addListener('clusteringend', this.onClusteringEnd.bind(this));
    }

    addComponentDestroyListener() {
        this.$scope.$on('$destroy', this.onDestroyComponent.bind(this));
    }

    onClusteringEnd() {
        if (this.map.getZoom() > this.markerClustererOptions.maxZoom) {

            let shops = this.getAllMarkersFromClusterer()
                .filter(this.filterMarkersInBounds.bind(this))
                .sort(this.sortMarkersClosestToSearchedPlaceCoordinates.bind(this))
                .map(this.getShopsFromMarker)
                .map(this.getDistanceBetweenShopAndSearchedPlaceCoordinates.bind(this));

            let smartStores = shops.filter(this.filterSmartStores);

            let shopsWithoutSmartStores = shops.filter(this.filterOutSmartStores);

            let allShops = smartStores.concat(shopsWithoutSmartStores);

            this.storeServ.dispatch({
                type: 'SET_SHOPS_IN_BOUNDS',
                shopsInBounds: allShops.length > 0 ? allShops : null
            });
        } else {
            this.storeServ.dispatch({
                type: 'SET_SHOPS_IN_BOUNDS',
                shopsInBounds: null
            });
        }
    }

    getAllMarkersFromClusterer() {
        return this.markerClusterer.getMarkers();
    }

    filterMarkersInBounds(marker) {
        return this.map.getBounds().contains(marker.getPosition());
    }

    getShopsFromMarker(marker) {
        return marker.customProperties.shop;
    }

    sortMarkersClosestToSearchedPlaceCoordinates(a, b) {
        var searchedPlaceCoordinates = this.storeServ.getState().searchedPlaceCoordinates;

        if (searchedPlaceCoordinates) {

            let searchedPlaceLocation = searchedPlaceCoordinates.location;
            let searchedPlaceLatLng = this.mapHelperServ.getLatLng(searchedPlaceLocation.lat, searchedPlaceLocation.lng);

            return this.mapHelperServ._calcDistanceBetweenTwoPositions(searchedPlaceLatLng, a.getPosition()) - this.mapHelperServ._calcDistanceBetweenTwoPositions(searchedPlaceLatLng, b.getPosition());
        } else {
            return 0;
        }
    }

    getDistanceBetweenShopAndSearchedPlaceCoordinates(shop) {
        var searchedPlaceCoordinates = this.storeServ.getState().searchedPlaceCoordinates;

        if (searchedPlaceCoordinates) {

            let searchedPlaceLocation = searchedPlaceCoordinates.location;
            let shopCopy = angular.copy(shop);

            shopCopy.distance = this.mapHelperServ._formatDistance(
                this.mapHelperServ._calcDistanceBetweenTwoPositions(
                    this.mapHelperServ.getLatLng(searchedPlaceLocation.lat, searchedPlaceLocation.lng),
                    this.mapHelperServ.getLatLng(shopCopy.lat, shopCopy.lng)
                )
            );

            return shopCopy;
        } else {
            return shop;
        }
    }

    filterSmartStores(a, b) {
        return a.type === 'smartStore';
    }

    filterOutSmartStores(a, b) {
        return a.type !== 'smartStore';
    }

    onDestroyComponent() {
        this.clusteringEndListener.remove();

        this.storeServ.getState().shopsInBounds && this.storeServ.dispatch({
            type: 'SET_SHOPS_IN_BOUNDS',
            shopsInBounds: null
        });
    }
}

ShopsInBoundsCtrl.$inject = ['$scope', 'storeServ', 'mapServ', 'mapHelperServ'];

var shopsInBoundsDirective = function() {
    return {
        restrict: 'E',
        scope: {},
        controllerAs: 'vm',
        controller: ShopsInBoundsCtrl,
        bindToController: {
            map: '=',
            markerClusterer: '='
        }
    };
};

export default shopsInBoundsDirective;
